import { useTheme } from '@mui/material';
import { ListItem } from '../ListItem/ListItem';

export const NavListItems = ({ sx, onClick, listItems }) => {
  const theme = useTheme();

  return (
    <>
      {listItems?.map((item) => (
        <ListItem
          key={item.name}
          text={item.name}
          to={item.to}
          theme={theme}
          sx={sx}
          onClick={onClick}
        />
      ))}
    </>
  );
};
